import type { FC } from 'react';

import IconCategory from './CategoryIcon';

interface ITitle {
  name: string;
  imageUrl?: string;
  scImageUrl?: string;
}

const Title: FC<ITitle> = ({ name, imageUrl, scImageUrl }) => {
  return (
    <div className="games__title">
      <IconCategory imageUrl={imageUrl} name={name} scImageUrl={scImageUrl} />
      <h2 className="games__title-text">{name}</h2>
      <IconCategory imageUrl={imageUrl} name={name} scImageUrl={scImageUrl} />
    </div>
  );
};

export default Title;
